import { SxProps } from "@mui/material"

export const getFormControlStyles = (active: boolean): SxProps => ({
  backgroundColor: "#fff",
  border: "1px solid rgb(128, 128, 128)",
  borderRadius: "4px",
  cursor: "pointer",
  ...(active
    ? {
        border: "1px solid #000",
        outline: "1px solid #333",
      }
    : {}),
  "&:hover, &:focus": {
    border: "1px solid #000",
  },
  "&:focus": {
    outline: "1px solid #333",
  },
  WebkitTapHighlightColor: "transparent",
})

export const calendarIconStyles: SxProps = {
  position: "absolute",
  right: "9px",
  top: "calc(50% - .5em)",
  fill: "rgba(0, 0, 0, 0.54)",
  fontSize: "20px",
}

export const labelStyles: SxProps = {
  cursor: "pointer",
}

export const dateDisplayStyles: SxProps = {
  fontWeight: 600,
  textAlign: "left",
  padding: "31px 16px 7px",
}
